import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { paths } from '@app/constants';

export interface AddedToCartData {
  termDays?: number;
  productPremiumTerm?: number;
  productName: string;
  productCountry?: string;
};

@Component({
  selector: 'app-added-to-cart',
  templateUrl: './added-to-cart.component.html',
  styleUrls: ['./added-to-cart.component.scss']
})
export class AddedToCartComponent implements OnInit {
  dialogData: AddedToCartData;

  constructor(
    public dialogRef: MatDialogRef<AddedToCartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddedToCartData,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.dialogData = this.data;

    const productFullName = this.dialogData.productName;
    if (productFullName.indexOf("-") > 0) {
      this.dialogData.productName = productFullName.split(/\s*-\s*/i)[0].trim();
      this.dialogData.productCountry = productFullName.split(/\s*-\s*/i)[1].trim();
    }

    if (this.dialogData.termDays) {
      this.dialogData.productPremiumTerm = (this.dialogData.termDays > 0)
        ? Math.floor(this.dialogData.termDays / 30)
        : 12;
    } else this.dialogData.productPremiumTerm = 0
  }

  continue() {
    this.dialogRef.close();
  }

  goToCart() {
    this.router.navigate([paths.PAYMENT], { replaceUrl: false });
    this.dialogRef.close();
  }
}
